var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1Sensor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.88 38a20.81 20.81 0 01-40.74 6h4.24a16.81 16.81 0 100-12h-4.24a20.81 20.81 0 0140.74 6zm-20.82 8.31A8.3 8.3 0 0146.32 44h-5a12.31 12.31 0 100-12h5a8.31 8.31 0 115.74 14.31zM49 40.54A3.999 3.999 0 0052.06 42a4 4 0 100-8A4 4 0 0049 35.46c-.141.17-.268.35-.38.54H31.11l-1.45-4-5.44-15-9.38 30.49L9.2 36H3v4h3.7l9 18.31 8.83-28.74L27 36.4l1.3 3.6h20.32c.112.19.239.37.38.54z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Sensor.507d729b.svg";
export { SvgG1Sensor as ReactComponent };